import { ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export function BodyPortal({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setTarget(document.body);
  }, []);

  if (!target) return null;
  return createPortal(children, target);
}
